import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background: rgba(10, 10, 10, 0.95);
  backdrop-filter: blur(10px);
  border-top: 2px solid #00ff88;
  padding: 2rem 0;
  margin-top: auto;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const FooterTitle = styled.h3`
  color: #00ff88;
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
`;

const FooterLink = styled(Link)`
  color: #ffffff;
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.3s ease;

  &:hover {
    color: #00ff88;
  }
`;

const FooterText = styled.p`
  color: #cccccc;
  font-size: 0.9rem;
  margin: 0;
`;

const Copyright = styled.div`
  text-align: center;
  padding: 1rem 0;
  border-top: 1px solid #333;
  margin-top: 1rem;
`;

const CopyrightText = styled.p`
  color: #888;
  font-size: 0.8rem;
  margin: 0;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <FooterTitle>Skylink</FooterTitle>
          <FooterText>Connecting families through secure communication</FooterText>
        </FooterSection>

        <FooterSection>
          <FooterTitle>Legal</FooterTitle>
          <FooterLink to="/privacy-policy">Privacy Policy</FooterLink>
          <FooterLink to="/terms">Terms of Service</FooterLink>
        </FooterSection>

        <FooterSection>
          <FooterTitle>Support</FooterTitle>
          <FooterLink to="/support">Customer Support</FooterLink>
        </FooterSection>

        <FooterSection>
          <FooterTitle>Contact</FooterTitle>
          <FooterText>Email: connectinoutinc@gmail.com</FooterText>
          <FooterText>Customer Service: (617) 370-1566</FooterText>
        </FooterSection>

        <FooterSection>
          <FooterTitle>Services</FooterTitle>
          <FooterLink to="/signup">Sign Up</FooterLink>
          <FooterLink to="/inmate-signup">Create Inmate Account</FooterLink>
          <FooterLink to="/load-money">Load Money</FooterLink>
        </FooterSection>
      </FooterContent>

      <Copyright>
        <CopyrightText>
          © 2025 Skylink, Inc. All rights reserved.
        </CopyrightText>
      </Copyright>
    </FooterContainer>
  );
};

export default Footer; 